import React, { createContext } from "react";

export const DeviceContext = createContext({});
